<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive :include="cachedViews">
      <component :is="Component" :key="route.fullPath" />
    </keep-alive>
  </router-view>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const cachedViews = ref([])

watch(route, (to) => {
  if (to.meta.keepAlive && !cachedViews.value.includes(to.name)) {
    cachedViews.value.push(to.name)
  }
}, { immediate: true })

</script>

<style>
#app {
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: PingFang-SC-Regular;
  font-size: 12px;
  text-align: center;
  color: rgba(0, 0, 0, .9);
  overflow: hidden;
}

#appContent {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
